export function formatDateLabel(
  value,
  { dateStyle = 'medium', timeStyle } = {},
) {
  if (!value) {
    return '';
  }

  const date = value instanceof Date ? value : new Date(value);

  if (!Number.isFinite(date.getTime())) {
    return String(value);
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle,
    ...(timeStyle ? { timeStyle } : {}),
  }).format(date);
}
